/**
 * Browse All Products flyout — dynamic featured rail.
 * Per Claude Design handoff §5 + Jon directive 2026-05-26 12:56 AEST
 * (click-only drill, not hover).
 *
 * Listens for custom events broadcast by VerticalTabsMenu when an L1 or
 * L2 is clicked, shows the matching <aside class="mm-rail" data-l1-key>
 * + its matching <div class="mm-rail__body" data-l2-key> within, hides
 * the rest. Updates the rail heading label.
 *
 * Selector contract (must match header-vertical-tabs-menu.liquid):
 *   [data-vertical-tabs-panel]            → flyout root
 *   .mm-rail[data-l1-key="<handle>"]      → rail for that L1
 *   .mm-rail__body[data-l2-key="<handle>"]→ per-L2 card set
 *   .mm-rail__body[data-default]          → fallback (L1) cards
 *   [data-l2-label]                       → rail heading text node
 *
 * Events:
 *   vtm:l1-active { l1Key, l1Index }
 *   vtm:l2-active { l2Key, l2Index, parentL1Key }
 */

(() => {
  const panels = document.querySelectorAll("[data-vertical-tabs-panel]");
  panels.forEach((panel) => {
    const railsByL1 = new Map();
    panel.querySelectorAll(".mm-rail").forEach((rail) => {
      railsByL1.set(rail.dataset.l1Key, rail);
    });
    if (railsByL1.size === 0) return;

    let activeL1 = null;

    function showRail(l1Key, l2Key, l2Label) {
      railsByL1.forEach((rail, key) => {
        const matches = key === l1Key;
        rail.hidden = !matches;
        if (!matches) return;

        // Swap body.
        rail.querySelectorAll(".mm-rail__body").forEach((body) => {
          const isMatch = l2Key
            ? body.dataset.l2Key === l2Key
            : body.hasAttribute("data-default");
          body.hidden = !isMatch;
        });

        // Update heading label.
        const labelEl = rail.querySelector("[data-l2-label]");
        if (labelEl) {
          labelEl.textContent = (
            l2Label ||
            rail.dataset.l1Label ||
            ""
          ).trim();
        }
      });
    }

    // Initialise: show the rail matching the L1 the Liquid marked
    // active on first render. Falls back to the first rail in the DOM.
    function pickInitialL1() {
      const activeL1Row = panel.querySelector("[data-l1-row].active");
      if (activeL1Row && railsByL1.has(activeL1Row.dataset.l1Key)) {
        return activeL1Row.dataset.l1Key;
      }
      return railsByL1.keys().next().value;
    }

    activeL1 = pickInitialL1();
    if (activeL1) showRail(activeL1, null, null);

    // L1 click handler from VerticalTabsMenu.
    panel.addEventListener("vtm:l1-active", (e) => {
      activeL1 = e.detail.l1Key;
      showRail(activeL1, null, null);
    });

    // L2 click handler from VerticalTabsMenu.
    panel.addEventListener("vtm:l2-active", (e) => {
      const { l2Key, parentL1Key } = e.detail;
      const l2Row = panel.querySelector(
        `[data-l2-row][data-l2-key="${CSS.escape(l2Key)}"]`,
      );
      const l2Label =
        l2Row?.querySelector(".vtm-link-label")?.textContent?.trim() || "";
      showRail(parentL1Key || activeL1, l2Key, l2Label);
    });

    // Reset when flyout closes.
    const verticalTabs = panel.closest("vertical-tabs-menu");
    if (verticalTabs) {
      const observer = new MutationObserver(() => {
        if (!verticalTabs.classList.contains("is-open")) {
          activeL1 = pickInitialL1();
          if (activeL1) showRail(activeL1, null, null);
        }
      });
      observer.observe(verticalTabs, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }
  });
})();
